const KenloIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="6" fill="#F82E52" />
      <g clipPath="url(#clip0_288_2129)">
        <path
          d="M17.7689 16.5817C17.8418 16.6492 17.9 16.731 17.9397 16.8218C17.9795 16.9128 18 17.0108 18 17.1098C18 17.209 17.9795 17.307 17.9397 17.3979C17.9 17.4888 17.8418 17.5705 17.7689 17.6381C17.6175 17.7784 17.4183 17.8564 17.2114 17.8564C17.0044 17.8564 16.8052 17.7784 16.6538 17.6381L12.0303 13.279L7.33573 17.642C7.18561 17.7797 6.98885 17.8563 6.78453 17.8565C6.68267 17.8546 6.58183 17.836 6.48608 17.8014C6.34579 17.7506 6.22426 17.6589 6.13749 17.5381C6.05072 17.4173 6.00279 17.2732 6 17.1248V6.90268C6.01013 6.69824 6.09895 6.5055 6.24807 6.36438C6.39718 6.22325 6.59518 6.14453 6.80105 6.14453C7.00692 6.14453 7.20492 6.22325 7.35404 6.36438C7.50316 6.5055 7.59198 6.69824 7.60211 6.90268V15.3058L16.0278 7.47004C16.1792 7.32947 16.3786 7.25128 16.5857 7.25128C16.7929 7.25128 16.9924 7.32947 17.1438 7.47004C17.2164 7.53776 17.2743 7.61957 17.314 7.71043C17.3535 7.80128 17.374 7.89924 17.374 7.99825C17.374 8.09728 17.3535 8.19524 17.314 8.2861C17.2743 8.37695 17.2164 8.45876 17.1438 8.52647L13.1278 12.2583L17.7689 16.5817Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_288_2129">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default KenloIcon;
